/**
 * Sales Invoice Screen (6.5.1)
 * Renders the exact POS terminal prototype via PosTerminalEmbed (see that file for details).
 */
import React from 'react';
import PosTerminalEmbed from '../billing/PosTerminalEmbed';

const SalesInvoiceScreen = ({ isPosMaximized, setIsPosMaximized }) => (
  <PosTerminalEmbed isPosMaximized={isPosMaximized} setIsPosMaximized={setIsPosMaximized} />
);

export default SalesInvoiceScreen;
